module.exports = __webpack_public_path__ + "img/image13.88dba11c.jpeg";